/**
 * Mapea mensajes de error del backend/callback a mensajes amigables para el usuario
 * y determina el tipo de error para mostrar la información apropiada.
 */

/** sessionStorage key escrita en Callback y leída en AuthErrorFallback */
export const AUTH_ERROR_KEY = 'auth_error';

export type AuthErrorReason =
  | 'invalid_email_domain'
  | 'not_registered'
  | 'not_enabled'
  | 'auth0_error'
  | 'generic';

export interface AuthErrorInfo {
  reason: AuthErrorReason;
  userMessage: string;
  detail?: string;
}

const CONTACT_MESSAGE =
  'No estás habilitado para esta cursada. De creer que se debe a un problema, contactate con la cátedra o itbaleetpi@gmail.com';

export function parseAuthError(rawMessage: string | null): AuthErrorInfo {
  if (!rawMessage || typeof rawMessage !== 'string') {
    return {
      reason: 'generic',
      userMessage: CONTACT_MESSAGE,
    };
  }

  const msg = rawMessage.trim().toLowerCase();

  if (msg.includes('itba.edu.ar') || msg.includes('correo institucional')) {
    return {
      reason: 'invalid_email_domain',
      userMessage:
        'Solo se permiten cuentas con correo institucional @itba.edu.ar. Por favor iniciá sesión con tu correo institucional.',
      detail: rawMessage,
    };
  }

  if (msg.includes('not registered') || msg.includes('no registrado')) {
    return {
      reason: 'not_registered',
      userMessage: CONTACT_MESSAGE,
      detail: rawMessage,
    };
  }

  if (
    msg.includes('account is disabled') ||
    msg.includes('no habilitado') ||
    msg.includes('deshabilitado')
  ) {
    return {
      reason: 'not_enabled',
      userMessage: CONTACT_MESSAGE,
      detail: rawMessage,
    };
  }

  // Auth0 errors típicos (access_denied, login_required, etc.)
  if (
    msg.includes('access_denied') ||
    msg.includes('login_required') ||
    msg.includes('invalid')
  ) {
    return {
      reason: 'auth0_error',
      userMessage: CONTACT_MESSAGE,
      detail: rawMessage,
    };
  }

  // Fallback para cualquier otro error (401, 403, 500, etc.)
  return {
    reason: 'generic',
    userMessage: CONTACT_MESSAGE,
    detail: rawMessage,
  };
}
